import { useContext } from 'react';
import { GiveRatingContext } from 'providers/GiveRating';

const useGiveRating = () => useContext(GiveRatingContext);

export default useGiveRating;
